import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Mixpanel from "../../../services/mixpanel";
import { useLocation } from "react-router-dom";
import { AIRequestFactory, CarouselsRequestFactory } from "../../../api/requestFactory";
import useRequest from "../../../api/useRequest";
import { NotificationContext } from "../../../context/notification-context";
import { GetTemplateByID } from "./templates";
import { getStoredWorkspace } from "../../../api/workspace";
import CarouselsHeader from "./carousel-header";

function  TextToCarousel() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { carousel, numberOfSlides } = state || {};
  const { showNotification } = useContext(NotificationContext);
  const { requestMaker } = useRequest();

  useEffect(() => {
    Mixpanel.track("Text to Carousel Started", {carousel_id: carousel.id});
    let post = {
      text: carousel.content,
    }
    let currentTemplate = GetTemplateByID(carousel.template_id);
    let schema = {
      slides: [],
    };
    for (var i = 0; i < currentTemplate.slides.length; i++) {
      let slide = currentTemplate.slides[i];
      let elements = slide.elements;
      let newElements = [];
      for (var j = 0; j < elements.length; j++) {
        // copy over the elements of type multiline and text. only copy value and max_words
        if (elements[j].type === "multiline" || elements[j].type === "text") {
          newElements.push({
            type: elements[j].type,
            value: elements[j].value,
            max_words: elements[j].max_words,

          });
        }else {
          newElements.push({
            type: elements[j].type,
          });
        }
      }
      schema.slides.push({
        elements: newElements,
        slide_type: slide.slide_type,
      });
    }

    requestMaker(AIRequestFactory.createGenerateCarouselContentRequest(post, JSON.stringify(schema.slides), numberOfSlides)).then((data) => {
      // iterate over the each element of the slides
      let newslides = [];

      let outputSlides = data.slides;
      for (var i = 0; i < outputSlides.length; i++) {
        let slide_type = outputSlides[i].slide_type;

        // get the slide type from the template
        let templateSlide = currentTemplate.slides.find((slide) => {
          return slide.slide_type === slide_type;
        });

        let elements = JSON.parse(JSON.stringify(templateSlide.elements));
        let newElements = [];

        let aiElements = outputSlides[i].elements;

        for (var j = 0; j < elements.length; j++) {
          let newElement = elements[j];
          if(elements[j].type === 'multiline' || elements[j].type === 'text'){
            newElement.value = aiElements[j]?.value || "";
          }
          newElements.push(newElement);
        }
        let newSlide = JSON.parse(JSON.stringify(templateSlide));
        newSlide.elements = newElements;
        newslides.push(newSlide);
      }
      Mixpanel.track("Text to Carousel Completed", {carousel_id: carousel.id});
      // update the carousel with the new slides
      requestMaker(CarouselsRequestFactory.createUpdateCarouselRequest(carousel.id, newslides, carousel.common_settings, carousel.content)).then((response) => {
        const currentWorkspaceId = getStoredWorkspace();
        if(carousel.template_id === "4"){
          navigate(`/ai/carousels/${carousel.id}?type=advanced&workspace_id=${currentWorkspaceId}`);
        }else{
          navigate(`/ai/carousels/${carousel.id}?workspace_id=${currentWorkspaceId}`);
        }
      }).catch((err) => {
        showNotification({
          title: 'Something went wrong',
          content: 'Cannot create content, please try again.'
        }, 'error')
        console.error(err);
      })

    }).catch((err) => {
      showNotification({
        title: 'Something went wrong',
        content: 'Cannot create content, please try again.'
      }, 'error')
      console.error(err);
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestMaker, carousel]);


  return (
      <div className="fixed inset-0 z-20 flex flex-col bg-white">
        <CarouselsHeader
          title="Text to Carousel"
          subTitle="with AI-powered carousel generation"
          onBack={() => {
            const currentWorkspaceId = getStoredWorkspace();
            navigate(`/ai/carousels?workspace_id=${currentWorkspaceId}`);
          }}
        />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center px-4">
            <div className="flex justify-center items-end gap-1 mb-8">
              <div
                className="w-1 h-8 bg-blue-500 rounded-full animate-bounce"
                style={{
                  animationDelay: "0ms",
                  animationDuration: "1s",
                }}
              ></div>
              <div
                className="w-1 h-8 bg-blue-500 rounded-full animate-bounce"
                style={{
                  animationDelay: "100ms",
                  animationDuration: "1s",
                }}
              ></div>
              <div
                className="w-1 h-8 bg-blue-500 rounded-full animate-bounce"
                style={{
                  animationDelay: "200ms",
                  animationDuration: "1s",
                }}
              ></div>
              <div
                className="w-1 h-8 bg-blue-500 rounded-full animate-bounce"
                style={{
                  animationDelay: "300ms",
                  animationDuration: "1s",
                }}
              ></div>
            </div>

          <div>
            <p className="text-base font-bold text-gray-950 mb-2">
              Be Patient!
            </p>
            <p className="mx-auto text-sm font-normal text-gray-600">
              ☕ Grab a coffee — It takes around 30 seconds for the AI to generate the carousel.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TextToCarousel;
